import React from 'react';
import Contact from '../components/Contact';
import { MapPin, Clock, ShieldCheck } from 'lucide-react';

const ContactPage = () => {
  return (
    <div className="min-h-screen bg-gray-950 pt-20 text-left">
      {/* Main Contact Form & Details Component */}
      <Contact />

      {/* Office Locations & Business Hours */}
      <section className="py-16 bg-slate-50 border-t border-b border-gray-200">
        <div className="container mx-auto px-6">
          <h2 className="text-2xl font-bold text-gray-900 mb-8 text-center">Global Locations & Operating Hours</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">

            <div className="bg-white border border-gray-200 rounded-2xl p-6 shadow-sm hover:shadow-md transition-all">
              <MapPin className="w-8 h-8 text-orange-500 mb-4" />
              <h3 className="text-lg font-bold text-gray-900 mb-2">India Headquarters</h3>
              <p className="text-base text-gray-600 leading-relaxed mb-3">
                HOASP International, K1, mahindra Enclave, Ghaziabad UP.
              </p>
              <div className="text-base text-orange-600 font-bold">+91 8796 118 101</div>
            </div>

            <div className="bg-white border border-gray-200 rounded-2xl p-6 shadow-sm hover:shadow-md transition-all">
              <Clock className="w-8 h-8 text-cyan-600 mb-4" />
              <h3 className="text-lg font-bold text-gray-900 mb-2">Operating Hours</h3>
              <p className="text-base text-gray-600 leading-relaxed mb-1">Monday – Friday: 9:00 AM – 5:00 PM IST</p>
              <p className="text-base text-gray-600 leading-relaxed mb-3">Saturday | Sunday: CLOSED</p>
              <div className="text-base text-orange-600 font-bold">24/7 Emergency Technical Support</div>
            </div>

            <div className="bg-white border border-gray-200 rounded-2xl p-6 shadow-sm hover:shadow-md transition-all">
              <ShieldCheck className="w-8 h-8 text-amber-500 mb-4" />
              <h3 className="text-lg font-bold text-gray-900 mb-2">Confidentiality Guarantee</h3>
              <p className="text-base text-gray-600 leading-relaxed mb-3">
                Every project consultation is protected under mutual Non-Disclosure Agreements (NDAs).
              </p>
              <div className="text-base text-blue-600 font-bold">100% Source Code Ownership</div>
            </div>

          </div>
        </div>
      </section>
    </div>
  );
};

export default ContactPage;
